<template>

    <form-section @submitted="addTeamMember">


        <template #title>

            <font-awesome-icon class="text-blue mr-6"
                style="width: 27px; height: 27px"
                :icon="['fas', 'user']">
            </font-awesome-icon>

            <div class="text-3xl font-nexa text-blue">
                {{ __('Add user') }}
            </div>

        </template>


        <template #form>

            <div class="col-span-6 sm:col-span-2">

                <Label class="text-black text-lg font-nexa mb-2"
                    for="email" :value="__('Email')" />

                <Input class="w-full text-black"
                    id="email" type="text" v-model="addTeamMemberForm.email" />

                <InputError class="mt-2"
                    :message="addTeamMemberForm.errors.email" />

            </div>


            <div class="col-span-3 sm:col-span-2">

                <Label class="text-black text-lg font-nexa mb-2"
                    for="role"
                    :value="__('Role')"/>

                <select class="block ring-0 focus:ring-blue border-gray-300 text-lg font-nexa rounded-md px-6 pt-5 pb-4 w-full text-black"
                    v-model="addTeamMemberForm.role">

                    <option v-for="role in availableRoles"
                        :value="role.key">

                        {{ __(role.name) }}

                    </option>

                </select>

            </div>


            <div class="col-span-3 sm:col-span-2">

                <Label class="text-black text-lg font-nexa mb-2"
                    for="language"
                    :value="__('Language')"/>

                <select class="block ring-0 focus:ring-blue border-gray-300 text-lg font-nexa rounded-md px-6 pt-5 pb-4 w-full text-black"
                    v-model="addTeamMemberForm.language">

                    <option v-for="language in languages"
                        :value="language.id">

                        {{ language.name }}

                    </option>

                </select>

            </div>

        </template>


        <template #actions>

            <Button class=""
                :class="{ 'opacity-25': addTeamMemberForm.processing }"
                :disabled="addTeamMemberForm.processing">
                {{ __('Add and invite new user') }}
            </Button>

            <ActionMessage class="ml-4"
                :on="addTeamMemberForm.recentlySuccessful"
                type="success">
                {{ __('User added an invitation has been sent') }}
            </ActionMessage>

        </template>

    </form-section>

</template>

<script>
import { defineComponent } from 'vue'
import ActionMessage from '@/Components/ActionMessage.vue'
import Button from '@/Components/Button.vue'
import FormSection from '@/Components/FormSection.vue'
import Input from '@/Components/Input.vue'
import InputError from '@/Components/InputError.vue'
import Label from '@/Components/Label.vue'

export default defineComponent({

    components: {
        ActionMessage,
        Button,
        FormSection,
        Input,
        InputError,
        Label,
    },

    props: [
        'team',
        'availableRoles',
    ],

    data() {
        return {

            languages: [
                {
                    id: 'da',
                    name: 'Dansk'
                },
                {
                    id: 'en',
                    name: 'English'
                },
            ],

            addTeamMemberForm: this.$inertia.form({
                email: '',
                role: _.last(this.availableRoles).key,
                language: 'da'
            }),

        }
    },

    methods: {

        addTeamMember() {

            this.addTeamMemberForm.post( this.route('team-members.store', this.team), {
                errorBag: 'addTeamMember',
                preserveScroll: true,
                onSuccess: () => this.addTeamMemberForm.reset(),
            });

        },

    },
})
</script>
